import { IconActionCall24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

type TChatHeaderCallButton = {
  phone: string;
  onClick: () => void;
};

export const ChatHeaderCallButton: React.FC<TChatHeaderCallButton> = ({ phone, onClick }) => {
  return (
    <a href={phone} className={styles['call_button']} onClick={onClick} data-testid="call_button">
      <IconActionCall24 color="icon-main-default" />
    </a>
  );
};
